export const getTableHeight = (winHeight: number): number => {
  const { top } =
    document.querySelector('.ant-table-body')?.getBoundingClientRect() ?? {};

  const DEFAULT_HEIGHT = 300;

  if (!top) {
    return DEFAULT_HEIGHT;
  }

  const paddingBottom = 28;
  const rowHeight = 37;
  const minRows = 7;
  const bodyHeight = winHeight - top - paddingBottom;
  const minReqHeight = rowHeight * minRows;

  return bodyHeight >= minReqHeight ? bodyHeight : minReqHeight + 250;
};
